var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { "padding-top": "10px", "max-width": "100%" } },
    [
      _vm.invalidTabs.length > 0
        ? _c(
            "div",
            { staticClass: "ml-1 mb-2 mt-2 warning" },
            [
              _c("pui-icon", { attrs: { "icon-name": "warning" } }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("operationalData.entryView.tabs.invalidData")) +
                  " " +
                  _vm._s(_vm.invalidTabs) +
                  " "
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "pui-tabs",
        { staticClass: "tabs", on: { changed: _vm.onTabChange } },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "pui-tab",
            {
              key: index,
              attrs: { title: _vm.$t(tab).toString().toUpperCase() },
            },
            [
              index == 0
                ? _c(
                    "div",
                    [_c("UnavailabilityTab", { key: _vm.tabsRefreshKey })],
                    1
                  )
                : _vm._e(),
              index == 1
                ? _c(
                    "div",
                    [_c("ComponentsTab", { key: _vm.tabsRefreshKey })],
                    1
                  )
                : _vm._e(),
              index == 2
                ? _c(
                    "div",
                    [_c("ThermalGenerationTab", { key: _vm.tabsRefreshKey })],
                    1
                  )
                : _vm._e(),
              index == 3
                ? _c(
                    "div",
                    [
                      _c("MaterialsTab", {
                        key: _vm.tabsRefreshKey,
                        attrs: { "material-type": "MA" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              index == 4
                ? _c(
                    "div",
                    [
                      _c("MaterialsTab", {
                        key: _vm.tabsRefreshKey,
                        attrs: { "material-type": "WA" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              index == 5
                ? _c(
                    "div",
                    [_c("QualityLosses", { key: _vm.tabsRefreshKey })],
                    1
                  )
                : _vm._e(),
              index == 6
                ? _c("div", [_c("CHPTab", { key: _vm.tabsRefreshKey })], 1)
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }